import { concatUrl } from './base'
import { appRequest } from './request'
import { encrypt } from '@gyasset/shared/utils';

export async function getCaptchaUrl () {
  const url = concatUrl('/captcha')
  const response = await fetch(url, {
    credentials: 'include',
    mode: 'cors'
  })
  const blob = await response.blob()
  const bs64 = await toBase64(blob)
  return bs64
}

function toBase64 (blob) {
  var reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise(resolve => {
    reader.onloadend = function () {
      const base64data = reader.result
      resolve(base64data)
    }
  })
}

const checkCaptchaUrl = concatUrl('/captcha/check')
export async function checkCaptcha (value) {
  const body = new FormData()
  body.append('value', value)
  const result = await appRequest(checkCaptchaUrl, {
    method: 'POST',
    body
  })
  return result
}

/***
 * 发送短信验证码
 * @type {*|string}
 * isQuicklyRegister  是否是快捷注册短信
 */
const registMessageUrl = concatUrl('/sms/regist')
export async function registMessage (mobile, captcha, areaCode, ticket, randStr) {
 await sendRegisterMessageNew({mobile, captcha, areaCode, ticket, randStr})
}
//重新构建 发送短信验证码方法的传参
export async function sendRegisterMessageNew (params) {
  let {mobile, captcha, areaCode, isQuicklyRegist, ticket, randStr} = params
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('captcha', captcha)
  body.append('ticket', ticket || '')
  body.append('randStr', randStr || '')
  areaCode &&  body.append('area_code', areaCode)
  isQuicklyRegist && body.append('isQuicklyRegist', isQuicklyRegist)
  const result = await appRequest(registMessageUrl, {
    method: 'POST',
    body
  })
  return result
}


/***
 * 注册发送语音验证码
 * @type {*|string}
 */
const registVoiceMessageUrl = concatUrl('/sms/regist/voice')
export async function registVoiceMessage (mobile, captcha, areaCode, ticket, randStr) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('captcha', captcha)
  body.append('ticket', ticket || '')
  body.append('randStr', randStr || '')
  if (areaCode) {
    body.append('area_code', areaCode)
  }
  console.log(body)
  const result = await appRequest(registVoiceMessageUrl, {
    method: 'POST',
    body
  })
  return result
}

const forgotMessageUrl = concatUrl('/sms/forgot')
export async function forgotMessage (mobile, captcha, areaCode, ticket, randStr) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('captcha', captcha)
  body.append('ticket', ticket || '')
  body.append('randStr', randStr || '')
  if (areaCode) {
    body.append('area_code', areaCode)
  }
  const result = await appRequest(forgotMessageUrl, {
    method: 'POST',
    body
  })
  return result
}

/**
 * 重置密码发送语音验证码
 */
const forgotVoiceMessageUrl = concatUrl('/sms/forgot/voice')
export async function forgotVoiceMessage (mobile, captcha, areaCode, ticket, randStr) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('captcha', captcha)
  body.append('ticket', ticket || '')
  body.append('randStr', randStr || '')
  if (areaCode) {
    body.append('area_code', areaCode)
  }
  const result = await appRequest(forgotVoiceMessageUrl, {
    method: 'POST',
    body
  })
  return result
}

// 二次验证，获取短信
export async function sendMessage(type, flag) {
  const result = await appRequest(concatUrl(`/user/identity?type=${type}&flag=${!!flag}`), {
    method: 'GET'
  })
  return result
}

// 二次验证，获取短信
export async function sendLoginMessage(mobile, username, password, ticket, randStr) {
  const body = new FormData()
  password = encrypt.md5(password)
  body.append('mobile', mobile)
  body.append('username', username)
  body.append('password', password)
  body.append('ticket', ticket ||'')
  body.append('randStr', randStr ||'')
  const result = await appRequest(concatUrl(`/login/sendLoginMsg`), {
    method: 'POST',
    body
  })
  return result
}


export async function sendLoginVoiceMessage(mobile, username, password, ticket, randStr) {
  const body = new FormData()
  password = encrypt.md5(password)
  body.append('mobile', mobile)
  body.append('username', username)
  body.append('password', password)
  body.append('ticket', ticket ||'')
  body.append('randStr', randStr ||'')
  const result = await appRequest(concatUrl(`/login/sendLoginVoiceMsg`), {
    method: 'POST',
    body
  })
  return result
}


export async function verifyLoginMsgCode(mobile, code) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('code', code)
  const result = await appRequest(concatUrl(`/login/verifyLoginMsgCode`), {
    method: 'POST',
    body
  })
  return result
}

/**
 * 身份语音验证码（赎回申请、撤销申请、修改申请、修改客户资料）
 * @param type
 * @returns {Promise<void>}
 */
export async function sendVoiceMessage(type) {
  const result = await appRequest(concatUrl(`/user/identity/voice?type=${type}`), {
    method: 'GET'
  })
  return result
}

// 二次验证，验证短信
export async function verifyMessage ({ mobile, areaCode, type }) {
  const body = new FormData()
  body.append('mobile', mobile)
  body.append('mobileMessage', areaCode)
  body.append('type', type)
  const result = await appRequest(concatUrl(`/user/identity/message`), {
    method: 'POST',
    body
  })
  return result
}

// 邮箱修改了后，在点击提交时增加一个手机验证码验证；
export async function verifyConfirmBasicInform ({ mobile, areaCode }) {
    const body = new FormData()
    body.append('mobile', mobile)
    body.append('mobileMessage', areaCode)
    const result = await appRequest(concatUrl(`/user/identity/verifyConfirmBasicInform`), {
        method: 'POST',
        body
    })
    return result
}


const forgetPassWordCheckCodeUrl = concatUrl('/regist/forgetPassWordCheckCode')
export async function forgetPassWordCheckCode(code) {
  const body = new FormData()
  body.append('captcha',code)
  return appRequest(forgetPassWordCheckCodeUrl,{
    method:'POST',
    body
  })
}


const toMobileVerifySmsCodeUrl = concatUrl('/sms/forgot/check')
export async function toMobileVerifySmsCode(mobile,code) {
  const body = new FormData()
  body.append('mobile',mobile)
  body.append('code',code)
  return appRequest(toMobileVerifySmsCodeUrl,{
    method:'POST',
    body
  })

}

/**
 * 一键注册  通过加密数据获取用户信息
 * @param sign
 * @returns {Promise<void>}
 */
const getQuickRegistClientInfoUrl = concatUrl('/regist/getQuickRegistClientInfo')
export async function getQuickRegisterClientInfo (sign) {
  const result = await appRequest(`${getQuickRegistClientInfoUrl}/${sign}`, {
    method: 'GET'
  })
  return result
}


